import React, { useEffect, useRef, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "../../../components/Modal/Modal";
import Typography from "../../../components/Typography/Typography";
import Button from "../../../components/Button/Button";
import { Dropdown, SelectOption } from "../../../components/DropDown/DropDown";
import DatePicker from "react-datepicker";
import styled from "styled-components";

import Textarea from "../../../components/TextArea/Textarea";
import myTeamImage from "../../../images/Profile.png";
import TextInput from "../../../components/TextInput/TextInput";
import Checkbox from "../../../components/CheckBox/CheckBox";
import RadioButton from "../../../components/Radio button/RadioButton";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import {
  getAccuruedOnAsync,
  getAdminTimeoffListAsync,
  getEffectiveAfterAsync,
  getEffectiveFromAsync,
  getLeaveAdjustmentModeAsync,
  getLeaveSandwichPolicyAsync,
  updateTimeOffAsync,
} from "../../../services/reducers/leaveReducer";
import { Field, Form, Formik, FormikHelpers } from "formik";
import * as Yup from "yup";
import { TOASTIFY_CONF } from "../../../services/sharedService/constants";
import { toast } from "react-toastify";
import { format } from "date-fns";
import { formatDate } from "../../../utils/common";
import EchopulseLoader from "../../loader/EchopulseLoader";
import Icons from "../../../components/Icons/Icon";
import ToggleButton from "../../../components/ToogleButton/ToogleButton";
import { CustomRightToolTip } from "./CreateTimeOffTypeModal";
import TimeOffSearchType from "../../../components/TimeOffSearchType/TimeOffSearchType";
import { commonDataAllAsync, getEmploymentTypeAsync, getGenderAsync, getRoleAsync, getUsersAsync } from "../../../services/reducers/appReducer";

export const EchoPulseDatePicker = styled.div`
  overflow: hidden;
  .react-datepicker__calendar-icon {
    display: none;
  }
  .react-datepicker-wrapper {
    width: 100%;
  }
  .react-datepicker-wrapper input {
    padding: 0.781rem 0.75rem;
    width: 100%;
    font-size: 0.875rem;
    font-weight: 400;
    color: #232323;
    border: 0.063rem solid #d9d9d9;
    border-radius: 0.375rem;
    background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 5.75C7.59 5.75 7.25 5.41 7.25 5V2C7.25 1.59 7.59 1.25 8 1.25C8.41 1.25 8.75 1.59 8.75 2V5C8.75 5.41 8.41 5.75 8 5.75Z' fill='%23292D32'/%3E%3Cpath d='M16 5.75C15.59 5.75 15.25 5.41 15.25 5V2C15.25 1.59 15.59 1.25 16 1.25C16.41 1.25 16.75 1.59 16.75 2V5C16.75 5.41 16.41 5.75 16 5.75Z' fill='%23292D32'/%3E%3Cpath d='M20.5 9.83997H3.5C3.09 9.83997 2.75 9.49997 2.75 9.08997C2.75 8.67997 3.09 8.33997 3.5 8.33997H20.5C20.91 8.33997 21.25 8.67997 21.25 9.08997C21.25 9.49997 20.91 9.83997 20.5 9.83997Z' fill='%23292D32'/%3E%3Cpath d='M16 22.75H8C4.35 22.75 2.25 20.65 2.25 17V8.5C2.25 4.85 4.35 2.75 8 2.75H16C19.65 2.75 21.75 4.85 21.75 8.5V17C21.75 20.65 19.65 22.75 16 22.75ZM8 4.25C5.14 4.25 3.75 5.64 3.75 8.5V17C3.75 19.86 5.14 21.25 8 21.25H16C18.86 21.25 20.25 19.86 20.25 17V8.5C20.25 5.64 18.86 4.25 16 4.25H8Z' fill='%23292D32'/%3E%3Cpath d='M8.5 14.5C8.37 14.5 8.24 14.47 8.12 14.42C8 14.37 7.89001 14.3 7.79001 14.21C7.70001 14.11 7.62999 14 7.57999 13.88C7.52999 13.76 7.5 13.63 7.5 13.5C7.5 13.24 7.61001 12.98 7.79001 12.79C7.89001 12.7 8 12.63 8.12 12.58C8.3 12.5 8.50001 12.48 8.70001 12.52C8.76001 12.53 8.82 12.55 8.88 12.58C8.94 12.6 9 12.63 9.06 12.67C9.11 12.71 9.15999 12.75 9.20999 12.79C9.24999 12.84 9.29999 12.89 9.32999 12.94C9.36999 13 9.40001 13.06 9.42001 13.12C9.45001 13.18 9.47001 13.24 9.48001 13.3C9.49001 13.37 9.5 13.43 9.5 13.5C9.5 13.76 9.38999 14.02 9.20999 14.21C9.01999 14.39 8.76 14.5 8.5 14.5Z' fill='%23292D32'/%3E%3Cpath d='M12 14.5C11.74 14.5 11.48 14.39 11.29 14.21C11.25 14.16 11.21 14.11 11.17 14.06C11.13 14 11.1 13.94 11.08 13.88C11.05 13.82 11.03 13.76 11.02 13.7C11.01 13.63 11 13.57 11 13.5C11 13.37 11.03 13.24 11.08 13.12C11.13 13 11.2 12.89 11.29 12.79C11.57 12.51 12.02 12.42 12.38 12.58C12.51 12.63 12.61 12.7 12.71 12.79C12.89 12.98 13 13.24 13 13.5C13 13.57 12.99 13.63 12.98 13.7C12.97 13.76 12.95 13.82 12.92 13.88C12.9 13.94 12.87 14 12.83 14.06C12.79 14.11 12.75 14.16 12.71 14.21C12.61 14.3 12.51 14.37 12.38 14.42C12.26 14.47 12.13 14.5 12 14.5Z' fill='%23292D32'/%3E%3Cpath d='M8.5 18C8.37 18 8.24 17.97 8.12 17.92C8 17.87 7.89001 17.8 7.79001 17.71C7.70001 17.61 7.62999 17.51 7.57999 17.38C7.52999 17.26 7.5 17.13 7.5 17C7.5 16.74 7.61001 16.48 7.79001 16.29C7.89001 16.2 8 16.13 8.12 16.08C8.49 15.92 8.92999 16.01 9.20999 16.29C9.24999 16.34 9.29999 16.39 9.32999 16.44C9.36999 16.5 9.40001 16.56 9.42001 16.62C9.45001 16.68 9.47001 16.74 9.48001 16.81C9.49001 16.87 9.5 16.94 9.5 17C9.5 17.26 9.38999 17.52 9.20999 17.71C9.01999 17.89 8.76 18 8.5 18Z' fill='%23292D32'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position-x: 97%;
    background-position-y: center;
    cursor: pointer;
  }

  .react-datepicker-wrapper input:focus {
    border: 0.063rem solid #4a154b;
    box-shadow: 0 0.625rem 1.25rem 0 rgba(0, 0, 0, 0.08);
    outline: 0;
  }
  .monthlyDate .react-datepicker-popper {
    width: max-content;
  }
  .monthlyDate .react-datepicker__month-text {
    padding: 0.9rem 0;
    width: 5.1rem;
    display: inline-block;
    font-size: 0.875rem;
    margin: 0.125rem;
  }
  .monthlyDate .react-datepicker__month-text--keyboard-selected {
    background-color: #f8f8f8;
    color: #000;
    font-weight: bolder;
  }
  .monthlyDate .react-datepicker__header {
    background-color: #fff;
    border: none;
    padding-top: 1.25rem;
  }
  .monthlyDate .react-datepicker__navigation {
    align-items: center;
    display: flex;
    padding: 0;
    text-align: center;
    top: 1.063rem;
  }
  .monthlyDate .react-datepicker__navigation--previous {
    left: 0.4375rem;
  }
  .monthlyDate .react-datepicker__navigation--next {
    rigth: 0.4375rem;
  }
  .monthlyDate .react-datepicker__navigation-icon:before {
    border-color: #232323;
    border-width: 0.094rem 0.094rem 0 0;
  }
  .monthlyDate .react-datepicker__day--in-range {
    background-color: #f15845;
  }
  .monthlyDate .react-datepicker__day--keyboard-selected {
    color: #fff;
  }
  .monthlyDate .react-datepicker__day--today {
    font-weight: 800;
  }
  .react-datepicker__month-text--in-range {
    background-color: #f15845;
  }
  .react-datepicker__day--keyboard-selected {
    background-color: #f15845;
  }
  .react-datepicker__day--selected {
    background-color: #f15845;
  }
`;

type Values = {
  timeOffType: number;
  holidayType: number;
  title: string;
  startDate: string;
  endDate: string;
  instructions: string;
  maxLeaves: string;
  occurrenceMode: any;
  isApplyOnProration: boolean;
  details: {
    holidayDate: string;
    holidayDayType: number;
    halfDayType: number;
  }[];
  fyId: string;
  leaveCode: string;
  effectiveAfterValue: number;
  effectiveAfter: number;
  effectiveFrom: number;
  accuruedOn: number;
  isCarryForwardAllowed: boolean;
  carryForwardUpperLimit: number;
  accrualUpperLimit: number;
  isLeaveAdjustmentAllowed: boolean;
  leaveAdjustmentMode: any;
  isLeaveSandwitchAllowed: boolean;
  weekendSandwich: number;
  holidaySandwich: number;
  isBackwardEntryAllowed: boolean;
  noOfAllowedPastDates: number;
  timeOffGenders: [
    {
      genderId: string,
      applicableTo: boolean,
      notApplicableTo: boolean
    }
  ],
  timeOffDesignations: [
    {
      designationId: string,
      applicableTo: boolean,
      notApplicableTo: boolean
    }
  ],
  timeOffLocations: [
    {
      locationId: string,
      applicableTo: boolean,
      notApplicableTo: boolean
    }
  ],
  timeOffRoles: [
    {
      roleId: string,
      applicableTo: boolean,
      notApplicableTo: boolean
    }
  ],
  timeOffEmploymentTypes: [
    {
      employmentTypeId: string,
      applicableTo: boolean,
      notApplicableTo: boolean
    }
  ],
  timeOffDepartments: [
    {
      departmentId: string,
      applicableTo: boolean,
      notApplicableTo: boolean
    }
  ],
  timeOffEmployees: [
    {
      identityId: string,
      applicableTo: boolean,
      notApplicableTo: boolean
    }
  ],
};

const TimeoffSchema = Yup.object().shape({
  title: Yup.string().required("Required"),
  maxLeaves: Yup.string().required("Required"),
});

type Option = {
  label: string;
  value: number;
};

type Member = {
  id: string;
  name: string;
};

type Props = {
  onClose: () => void;
  timeOffId: string;
  getTimeoffList: () => void;
  setEditTimeOff: React.Dispatch<React.SetStateAction<boolean>>;
  selectedTimeOffType: number;
};

const AdminEditTimeOffModal: React.FC<Props> = ({
  onClose,
  timeOffId,
  setEditTimeOff,
  getTimeoffList,selectedTimeOffType
}) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const dispatch = useAppDispatch();
  const [timeOffData, setTimeOffData] = useState<any>({});
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [daysDifference, setDaysDifference] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const [selectPeriodOptions, setSelectPeriodOptions] = useState<Option[]>([]);
  const [selectedEffectiveAfter, setSelectedEffectiveAfter] =
    useState<string>("");
  const [selectedEffectiveFrom, setSelectedEffectiveFrom] =
    useState<string>("");
  const leaveAdjustList = useAppSelector(
    (state: any) => state.leave.leaveAdjustList
  );
  const effectiveAfterList = useAppSelector(
    (state: any) => state.leave.effectiveAfterList
  );
  const effectiveFromList = useAppSelector(
    (state: any) => state.leave.effectiveFromList
  );
  const accuruedOnList = useAppSelector(
    (state: any) => state.leave.accuruedOnList
  );
  const leaveSandwichList = useAppSelector(
    (state: any) => state.leave.leaveSandwichList
  );
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [selectedEmployee, setSelectedEmployee] = useState<string[]>([]);
  const [notSelectedEmployee, setNotSelectedEmployee] = useState<string[]>([]);
  const [notSelectedOptions, setNotSelectedOptions] = useState<string[]>([]);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDropdownOpens, setIsDropdownOpens] = useState(false);
  const [designationList, setDesignationList] = useState<any>(null);
  const [locationList, setLocationList] = useState<any>(null);
  const [departmentList, setDepartmentList] = useState<any>(null);
  const [employeeType, setEmployeeType] = useState<any>(null);
  const [genderList, setGenderList] = useState<any>(null);
  const [userLists, setUserLists] = useState<any>(null);
  const [roleList, setRoleList] = useState<any>(null);
  const [applicableMembers, setApplicableMembers] = useState<Member[]>([]);
  const [notApplicableMembers, setNotApplicableMembers] = useState<Member[]>([]);
  const [isApplicableSelected, setIsApplicableSelected] = useState(false);
  const [isNotApplicableSelected, setIsNotApplicableSelected] = useState(false);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const availableOptions = [
    "Gender",
    "Designations",
    "Locations",
    "Roles",
    "Employment Type",
    "Departments",
  ];

  useEffect(() => {
    setLoading(true);
    const request: any = {
      Page: 1,
      PageSize: 50,
      SearchString: timeOffId,
      ShowHoliday:selectedTimeOffType === 0 ? true : false,
    };
    dispatch(getAdminTimeoffListAsync(request)).then((res) => {
      if (res.payload) {
        setTimeOffData(res.payload?.records[0]?.timeOffData[0]);
        setLoading(false);
      }
    });
  }, []);

  const holidayTypeOpt = [
    {
      label: "Fixed Holiday",
      value: 0,
    },
    {
      label: "Restricted Holiday",
      value: 1,
    },
  ];

  const dayType = [
    { label: "Full", value: 0 },
    { label: "Half", value: 1 },
  ];

  const prorationType = [
    { label: "Yes", value: 0 },
    { label: "No", value: 1 },
  ];

  useEffect(() => {
    if (startDate && endDate) {
      // console.log(startDate, "startDate");
      // console.log(endDate, "endDate");

      let monthsDifference =
        (endDate.getFullYear() - startDate.getFullYear()) * 12 +
        (endDate.getMonth() - startDate.getMonth());

      monthsDifference += 1;

      setDaysDifference(monthsDifference);
    }
  }, [startDate, endDate]);

  useEffect(() => {
    const startDates = timeOffData.startDate
      ? new Date(timeOffData.startDate)
      : null;
    const endDates = timeOffData.endDate ? new Date(timeOffData.endDate) : null;
    setStartDate(startDates);
    setEndDate(endDates);
  }, [timeOffData.startDate, timeOffData.endDate]);

  const handleDateChange = (
    date: Date | [Date, Date] | null,
    setFieldValue: (field: string, value: any) => void,
    values: Values,
    isStart: boolean
  ) => {
    //debugger;
    if (date === null) {
      setStartDate(null);
      setEndDate(null);
      // Clear details array
      setFieldValue("details", []);
    } else if (Array.isArray(date)) {
      const [start, end] = date;
      setStartDate(start);
      setEndDate(end);

      const details = [];
      let currentDate = new Date(start);
      while (currentDate <= end) {
        details.push({
          holidayDate: formatDate(currentDate),
          holidayDayType: 0,
          halfDayType: 0,
        });
        currentDate.setDate(currentDate.getDate() + 1);
      }
      setFieldValue("details", details);
    } else {
      // For single date picker, handle it accordingly
      if (values?.timeOffType === 0) {
        // Handle selection for Fixed Holiday type
        if (isStart) {
          setStartDate(date);
        } else {
          setEndDate(date);
        }
        const details = [];
        let currentDate = isStart
          ? date
            ? new Date(date)
            : null
          : startDate
            ? new Date(startDate)
            : null;

        const endDateToIterate = isStart ? endDate : date;
        while (
          currentDate &&
          endDateToIterate &&
          currentDate <= endDateToIterate
        ) {
          details.push({
            holidayDate: currentDate ? formatDate(currentDate) : "",
            holidayDayType: 0,
            halfDayType: 0,
          });
          currentDate.setDate(currentDate.getDate() + 1);
        }
        setFieldValue("details", details);
      } else {
        // Handle selection for Leave type
        setStartDate(date);
        setEndDate(null);
        setFieldValue("details", [
          {
            holidayDate: formatDate(date),
            holidayDayType: 0,
            halfDayType: 0,
          },
        ]);
      }
    }
  };

  const calculateDiffInMonths = (startDate: Date, endDate: Date) => {
    const diffYears = endDate.getFullYear() - startDate.getFullYear();
    const diffMonths = endDate.getMonth() - startDate.getMonth();

    let diffDays = endDate.getDate() - startDate.getDate();

    if (diffDays < 0) {
      diffDays += new Date(
        endDate.getFullYear(),
        endDate.getMonth(),
        0
      ).getDate();
    }
    const diffInMonths = diffYears * 12 + diffMonths + (diffDays >= 0 ? 1 : 0);

    return diffInMonths;
  };

  useEffect(() => {
    if (startDate && endDate) {
      const diffInMonths = calculateDiffInMonths(startDate, endDate);
      let options: Option[] = [];
      if (diffInMonths >= 12) {
        options = [
          { label: "Monthly", value: 0 },
          { label: "Quarterly", value: 1 },
          { label: "Half Yearly", value: 2 },
          { label: "Annually", value: 3 },
          { label: "One-time", value: 4 },
        ];
      } else if (diffInMonths > 6 && diffInMonths < 12) {
        options = [
          { label: "Monthly", value: 0 },
          { label: "Quarterly", value: 1 },
          { label: "Half Yearly", value: 2 },
          { label: "One-time", value: 4 },
        ];
      } else if (diffInMonths > 3 && diffInMonths <= 6) {
        options = [
          { label: "Monthly", value: 0 },
          { label: "Quarterly", value: 1 },
          { label: "One-time", value: 4 },
        ];
      } else if (diffInMonths <= 3) {
        options = [{ label: "Monthly", value: 0 }, { label: "One-time", value: 4 }];
      } else {
        options = [];
      }

      setSelectPeriodOptions(options);
    }
  }, [startDate, endDate]);

  const getFrequencyText = (
    occurrenceMode: number | null,
    maxLeaves: string,
    daysDifference: number | null
  ) => {
    if (!maxLeaves || daysDifference === null) {
      return "0 day leave accrued per month";
    }
    let periodInMonths;
    let frequency;

    switch (occurrenceMode) {
      case 0:
        periodInMonths = 1;
        frequency = "every month";
        break;
      case 1:
        periodInMonths = 3;
        frequency = "every 3 months";
        break;
      case 2:
        periodInMonths = 6;
        frequency = "every 6 months";
        break;
      case 3:
        periodInMonths = 12;
        frequency = "every year";
        break;
      default:
        periodInMonths = 1;
        frequency = "every month";
        break;
    }
    const leavesPerPeriod = Math.ceil(daysDifference / periodInMonths);
    const leavesAccrued = (Number(maxLeaves) / leavesPerPeriod).toFixed(2);

    return `${leavesAccrued} will be credited ${frequency}`;
  };

  useEffect(() => {
    dispatch(getEffectiveAfterAsync());
    dispatch(getEffectiveFromAsync());
    dispatch(getAccuruedOnAsync());
    dispatch(getLeaveAdjustmentModeAsync());
    dispatch(getLeaveSandwichPolicyAsync());
  }, []);

  const handleEffectiveFromChange = (
    value: SelectOption | SelectOption[] | null
  ) => {
    if (value && !Array.isArray(value)) {
      setSelectedEffectiveFrom(value.value as string);
    }
  };

  const handleOptionSelect = (option: string, event: React.MouseEvent) => {
    if (!selectedOptions.includes(option)) {
      setSelectedOptions([...selectedOptions, option]);
      // setFieldValue('selectedOptions', [...selectedOptions, option]);
      setNotSelectedOptions(notSelectedOptions.filter((opt) => opt !== option));
    }
    setIsDropdownOpen(false);
  };

  const handleOptionSelects = (option: string) => {
    if (!notSelectedOptions.includes(option)) {
      setNotSelectedOptions([...notSelectedOptions, option]);
      setSelectedOptions(selectedOptions.filter((opt) => opt !== option));
    }
    setIsDropdownOpens(false);
  };

  // const filteredOptions = (availableOptions).filter(
  //   (option) => !selectedOptions.includes(option) && !notSelectedOptions.includes(option)
  // );
  const getUniqueCategories = (options: string[]) => {
    return Array.from(new Set(options.map((option) => option.split('.')[0])));
  };

  const filteredOptions = availableOptions.filter(
    (option) =>
      !getUniqueCategories(selectedOptions).includes(option) &&
      !getUniqueCategories(notSelectedOptions).includes(option)
  );

  useEffect(() => {
    if (timeOffId && timeOffData) {

      const selectedDesignations = (timeOffData.timeOffDesignations || [])
        .filter((item: any) => item.applicableTo === true)
        .map((item: any) => `Designations.${item.designationId}`);

      const notSelectedDesignations = (timeOffData.timeOffDesignations || [])
        .filter((item: any) => item.notApplicableTo === true)
        .map((item: any) => `Designations.${item.designationId}`);

      const selectedRoles = (timeOffData.timeOffRoles || [])
        .filter((item: any) => item.applicableTo === true)
        .map((item: any) => `Roles.${item.roleId}`);

      const notSelectedRoles = (timeOffData.timeOffRoles || [])
        .filter((item: any) => item.notApplicableTo === true)
        .map((item: any) => `Roles.${item.roleId}`);

      const selectedEmployees = (timeOffData.timeOffEmployees || [])
        .filter((item: any) => item.applicableTo === true)
        .map((item: any) => `"".${item.identityId}`);

      const notSelectedEmployees = (timeOffData.timeOffEmployees || [])
        .filter((item: any) => item.notApplicableTo === true)
        .map((item: any) => `"".${item.identityId}`);

      const selectedGender = (timeOffData.timeOffGenders || [])
        .filter((item: any) => item.applicableTo === true)
        .map((item: any) => `Gender.${item.genderId}`);

      const notSelectedGender = (timeOffData.timeOffGenders || [])
        .filter((item: any) => item.notApplicableTo === true)
        .map((item: any) => `Gender.${item.genderId}`);

      const selectedLocations = (timeOffData.timeOffLocations || [])
        .filter((item: any) => item.applicableTo === true)
        .map((item: any) => `Locations.${item.locationId}`);

      const notSelectedLocations = (timeOffData.timeOffLocations || [])
        .filter((item: any) => item.notApplicableTo === true)
        .map((item: any) => `Locations.${item.locationId}`);
      const selectedEmploymentType = (timeOffData.timeOffEmploymentTypes || [])
        .filter((item: any) => item.applicableTo === true)
        .map((item: any) => `Employment Type.${item.employmentTypeId}`);

      const notSelectedEmploymentType = (timeOffData.timeOffEmploymentTypes || [])
        .filter((item: any) => item.notApplicableTo === true)
        .map((item: any) => `Employment Type.${item.employmentTypeId}`);

      const selectedDepartments = (timeOffData.timeOffDepartments || [])
        .filter((item: any) => item.applicableTo === true)
        .map((item: any) => `Departments.${item.departmentId}`);

      const notSelectedDepartments = (timeOffData.timeOffDepartments || [])
        .filter((item: any) => item.notApplicableTo === true)
        .map((item: any) => `Departments.${item.departmentId}`);
      setSelectedOptions([
        ...selectedDesignations,
        ...selectedRoles,
        // ...selectedEmployees,
        ...selectedGender,
        ...selectedLocations,
        ...selectedEmploymentType,
        ...selectedDepartments
      ]);
      setSelectedEmployee([...selectedEmployees]);
      setNotSelectedOptions([
        ...notSelectedDesignations,
        ...notSelectedRoles,
        // ...notSelectedEmployees,
        ...notSelectedGender,
        ...notSelectedLocations,
        ...notSelectedEmploymentType,
        ...notSelectedDepartments
      ]);
      setNotSelectedEmployee([...notSelectedEmployees])

      setIsApplicableSelected(selectedEmployees.length > 0);
      setIsNotApplicableSelected(notSelectedEmployees.length > 0);
    }
   
  }, [timeOffId, timeOffData]);
console.log(notSelectedEmployee, "notSelectedEmployee")
  const getListForOption = (option: any) => {
    switch (option) {
      case "Designations":
        // console.log("Returning designationList:", designationList);
        return designationList;
      case "Locations":
        return locationList;
      case "Departments":
        return departmentList;
      case "Employment Type":
        return employeeType;
      case "Gender":
        return genderList;
      case "Roles":
        return roleList;
      default:
        return userLists;
    }
  };

  const userApplicability = () => {
    const fetchDataByOption = (options: any) => {
      options.forEach((option: any) => {
        const [category, id] = option.split('.');
        switch (category) {
          case "Designations":
            const designationReqBody = {
              page: 1,
              pageSize: 1000,
              orderBy: "CreatedOn",
              statusFilter: [],
              isOrderByDesc: true,
              searchString: "",
            };
            dispatch(commonDataAllAsync({ typeName: "designation", reqBody: designationReqBody }))
              .then((res) => {
                setDesignationList(res?.payload?.records);
              });
            break;

          case "Locations":
            const locationReqBody = {
              page: 1,
              pageSize: 1000,
              orderBy: "CreatedOn",
              statusFilter: [],
              isOrderByDesc: true,
              searchString: "",
            };
            dispatch(commonDataAllAsync({ typeName: "location", reqBody: locationReqBody }))
              .then((res) => {
                setLocationList(res?.payload?.records);
              });
            break;

          case "Departments":
            const departmentReqBody = {
              page: 1,
              pageSize: 1000,
              orderBy: "CreatedOn",
              statusFilter: [],
              isOrderByDesc: true,
              searchString: "",
            };
            dispatch(commonDataAllAsync({ typeName: "department", reqBody: departmentReqBody }))
              .then((res) => {
                setDepartmentList(res?.payload?.records);
              });
            break;

          case "Employment Type":
            dispatch(getEmploymentTypeAsync()).then((res) => {
              setEmployeeType(res?.payload);
            });
            break;

          case "Gender":
            dispatch(getGenderAsync()).then((res) => {
              setGenderList(res?.payload);
            });
            break;

          case "Roles":
            dispatch(getRoleAsync({ name: "" })).then((res) => {
              setRoleList(res?.payload?.records);
            });
            break;

          default:
            const userRequest = {
              page: 1,
              pageSize: 2000,
            };
            dispatch(getUsersAsync(userRequest)).then((res) => {
              const activeUsers = res?.payload?.users?.filter((user: any) => user.status === "Active");
              setUserLists(activeUsers);
            });
            break;
        }
      });
    };

    fetchDataByOption(selectedOptions);
    fetchDataByOption(notSelectedOptions);
  };

  useEffect(() => {
    userApplicability();
  }, [selectedOptions, notSelectedOptions]);
  

  const getKeyForOption = (option: string) => {
    switch (option) {
      case "Designations":
        return "timeOffDesignations";
      case "Locations":
        return "timeOffLocations";
      case "Departments":
        return "timeOffDepartments";
      case "Employment Type":
        return "timeOffEmploymentTypes";
      case "Gender":
        return "timeOffGenders";
      case "Roles":
        return "timeOffRoles";
      case "":
        return "timeOffEmployees";
      default:
        return null;
    }
  };

  useEffect(() => {
    const userRequest = {
      page: 1,
      pageSize: 2000,
    };
    dispatch(getUsersAsync(userRequest)).then((res) => {
      const activeUsers = res?.payload?.users?.filter((user: any) => user.status === "Active");
      setUserLists(activeUsers);
    });
  }, []);

  const handleApplicableSelection = (members: any) => {
    setApplicableMembers(members);
    setIsApplicableSelected(members?.length > 0);
    setIsNotApplicableSelected(false);

  };

  const handleNotApplicableSelection = (members: any) => {
    setNotApplicableMembers(members);
    setIsNotApplicableSelected(members?.length > 0);
    setIsApplicableSelected(false);

  };
  console.log(isNotApplicableSelected, "isApplicableSelected")
  return (
    <Modal isOpen onClose={onClose} placement="right" size="medium">
      <Formik
        enableReinitialize
        initialValues={{
          timeOffType: timeOffId ? timeOffData?.timeOffType : "0",
          title: timeOffId ? timeOffData?.title : "",
          startDate: timeOffId ? timeOffData?.startDate : "",
          endDate: timeOffId ? timeOffData?.endDate : "",
          instructions: timeOffId ? timeOffData?.instructions : "",
          isApplyOnProration: timeOffId
            ? timeOffData?.isApplyOnProration
            : true,
          details:
            timeOffId && timeOffData?.details
              ? timeOffData.details.map((detail: any) => ({
                holidayDate: detail?.holidayDate,
                holidayDayType: detail?.holidayDayType,
                halfDayType: detail?.halfDayType,
              }))
              : [],
          holidayType: timeOffId ? timeOffData?.holidayType : 0,
          maxLeaves: timeOffId ? timeOffData?.maxLeaves : "",
          fyId: timeOffId ? timeOffData?.fyId : "",
          leaveCode: timeOffId ? timeOffData?.leaveCode : "",
          occurrenceMode: timeOffId ? timeOffData?.occurrenceMode : null,

          effectiveAfterValue: timeOffId
            ? timeOffData?.effectiveAfterValue
            : "",
          effectiveAfter: timeOffId ? timeOffData?.effectiveAfter : null,
          effectiveFrom: timeOffId ? timeOffData?.effectiveFrom : null,
          accuruedOn: timeOffId ? timeOffData?.accuruedOn : null,
          carryForwardUpperLimit: timeOffId
            ? timeOffData?.carryForwardUpperLimit
            : 0,
          isCarryForwardAllowed: timeOffId
            ? timeOffData?.isCarryForwardAllowed
            : false,
          isLeaveAdjustmentAllowed: timeOffId
            ? timeOffData?.isLeaveAdjustmentAllowed
            : false,
          accrualUpperLimit: timeOffId ? timeOffData?.accrualUpperLimit : 0,
          leaveAdjustmentMode: timeOffId
            ? timeOffData?.leaveAdjustmentMode
            : null,
          isLeaveSandwitchAllowed: timeOffId
            ? timeOffData?.isLeaveSandwitchAllowed
            : false,
          weekendSandwich: timeOffId ? timeOffData?.weekendSandwich : null,
          holidaySandwich: timeOffId ? timeOffData?.holidaySandwich : null,
          isBackwardEntryAllowed: timeOffId
            ? timeOffData?.isBackwardEntryAllowed
            : false,
          noOfAllowedPastDates: timeOffId
            ? timeOffData?.noOfAllowedPastDates
            : "",
          timeOffGenders: timeOffId && timeOffData?.timeOffGenders
            ? timeOffData?.timeOffGenders.map((member: any) => ({
              genderId: member.genderId,
              applicableTo: member.applicableTo,
              notApplicableTo: member.notApplicableTo
            })) : [],
          timeOffDesignations: timeOffId && timeOffData?.timeOffDesignations
            ? timeOffData?.timeOffDesignations.map((member: any) => ({
              designationId: member.designationId,
              applicableTo: member.applicableTo,
              notApplicableTo: member.notApplicableTo
            })) : [],

          timeOffLocations: timeOffId && timeOffData?.timeOffLocations
            ? timeOffData?.timeOffLocations.map((member: any) => ({
              locationId: member.locationId,
              applicableTo: member.applicableTo,
              notApplicableTo: member.notApplicableTo
            })) : [],
          timeOffRoles: timeOffId && timeOffData?.timeOffRoles
            ? timeOffData?.timeOffRoles.map((member: any) => ({
              roleId: member.roleId,
              applicableTo: member.applicableTo,
              notApplicableTo: member.notApplicableTo
            })) : [],
          timeOffEmploymentTypes: timeOffId && timeOffData?.timeOffEmploymentTypes
            ? timeOffData?.timeOffEmploymentTypes.map((member: any) => ({
              employmentTypeId: member.employmentTypeId,
              applicableTo: member.applicableTo,
              notApplicableTo: member.notApplicableTo
            })) : [],
          timeOffDepartments: timeOffId && timeOffData?.timeOffDepartments
            ? timeOffData?.timeOffDepartments.map((member: any) => ({
              departmentId: member.departmentId,
              applicableTo: member.applicableTo,
              notApplicableTo: member.notApplicableTo
            })) : [],
          timeOffEmployees: timeOffId && timeOffData?.timeOffEmployees
            ? timeOffData?.timeOffEmployees.map((member: any) => ({
              identityId: member.identityId,
              applicableTo: member.applicableTo,
              notApplicableTo: member.notApplicableTo
            })) : [],
        }}
        validationSchema={TimeoffSchema}
        onSubmit={async (
          values: Values,
          { setSubmitting }: FormikHelpers<Values>
        ) => {
          let formattedStartDate = startDate
            ? formatDate(startDate)
            : values.startDate;
          let formattedEndDate = endDate ? formatDate(endDate) : values.endDate;
          if (timeOffId) {
            //debugger;
            const reqBody: any = {
              ...values,
              timeOffType: values.timeOffType,
              holidayType: values.holidayType,
              title: values.title,
              startDate: formattedStartDate,
              endDate: formattedEndDate,
              instructions: values.instructions,
              maxLeaves: values.maxLeaves,
              isApplyOnProration: values.isApplyOnProration,
              details: values.details.map((detail: any) => ({
                holidayDate: detail.holidayDate,
                holidayDayType: detail.holidayDayType,
                halfDayType: detail.halfDayType,
              })),
              fyId: values.fyId,
              leaveCode: values.timeOffType === 1 ? values.leaveCode : "",
              occurrenceMode:
                values.timeOffType === 0 ? null : values.occurrenceMode,
              effectiveAfterValue:
                values.timeOffType === 0 ? null : values.effectiveAfterValue,
              effectiveAfter:
                values.timeOffType === 0 ? null : values.effectiveAfter,
              effectiveFrom:
                values.timeOffType === 0 ? null : values.effectiveFrom,
              accuruedOn: values.timeOffType === 0 ? null : values.accuruedOn,
              carryForwardUpperLimit:
                values.timeOffType === 0 ? null : values.carryForwardUpperLimit,
              isCarryForwardAllowed: values.isCarryForwardAllowed,
              isLeaveAdjustmentAllowed: values.isLeaveAdjustmentAllowed,
              accrualUpperLimit:
                values.timeOffType === 0 ? null : values.accrualUpperLimit,
              leaveAdjustmentMode:
                values.timeOffType === 0 ? null : values.leaveAdjustmentMode,
              isLeaveSandwitchAllowed: values.isLeaveSandwitchAllowed,
              weekendSandwich:
                values.timeOffType === 0 ? null : values.weekendSandwich,
              holidaySandwich:
                values.timeOffType === 0 ? null : values.holidaySandwich,
              isBackwardEntryAllowed: values.isBackwardEntryAllowed,
              noOfAllowedPastDates:
                values.timeOffType === 0 ? null : values.noOfAllowedPastDates,
            };

            const result = await dispatch(
              updateTimeOffAsync({ id: timeOffId, reqBody })
            );
            getTimeoffList();
            toast.success(`TimeOff Successfully Updated!`, TOASTIFY_CONF);
            setEditTimeOff(false);

            setSubmitting(false);
          }
        }}
      >
        {({
          errors,
          touched,
          setFieldValue,
          values,
          isSubmitting,
          setFieldTouched,
          submitForm,
          isValid,
          dirty,
        }) => {
          // console.log(values, "values");
          return (
            <Form className="w-full flex flex-col h-full">
              <ModalHeader className="bg-gray-200">
                <Typography className="font-bold text-gray-300" variant="h3">
                  Edit Time Off
                </Typography>
              </ModalHeader>
              {loading ? (
                <tr>
                  <td colSpan={3}>
                    <EchopulseLoader />
                  </td>
                </tr>
              ) : (
                <>
                  <ModalBody className="!px-0">
                    <div className="grid grid-cols-2 gap-[4.25rem] justify-start items-start w-full h-full ps-[3.25rem] pe-10">
                      <div className="h-auto pt-10 pb-20">
                        <div className="w-full pb-5 border-b border-gray-400">
                          <label className="text-400 font-medium text-gray-300 block mb-2">
                            Select Time off Type
                            <span className="text-primary-100 ps-0.5">*</span>
                          </label>
                          <div className="flex justify-start items-center gap-9 mt-3 [&>.inline-block>label>span]:text-gray-300 [&>.inline-block>label>span]:font-medium">
                            <Field
                              type="radio"
                              name="timeOffType"
                              value={0}
                              render={({ field }: any) => (
                                <RadioButton
                                  label="Holiday"
                                  {...field}
                                  onChange={() =>
                                    setFieldValue("timeOffType", 0)
                                  }
                                  selectedValue={values.timeOffType}
                                  disabled
                                // disabled={timeOffData?.isConsumed}
                                // disabled={
                                //   timeOffData?.leaveCode === "LOP" ||
                                //   timeOffData?.leaveCode === "ML" ||
                                //   timeOffData?.leaveCode === "PL" ||
                                //   timeOffData?.leaveCode === "EL" ||
                                //   timeOffData?.leaveCode === "BL" ||
                                //   timeOffData?.leaveCode === "CL" ||
                                //   timeOffData?.leaveCode === "SL" ||
                                //   timeOffData?.isConsumed
                                // }
                                />
                              )}
                            />
                            <Field
                              type="radio"
                              name="timeOffType"
                              value={1}
                              render={({ field }: any) => (
                                <RadioButton
                                  label="Leave"
                                  {...field}
                                  onChange={() =>
                                    setFieldValue("timeOffType", 1)
                                  }
                                  selectedValue={values.timeOffType}
                                  disabled
                                // disabled={timeOffData?.isConsumed}
                                // disabled={
                                //   timeOffData?.leaveCode === "LOP" ||
                                //   timeOffData?.leaveCode === "ML" ||
                                //   timeOffData?.leaveCode === "PL" ||
                                //   timeOffData?.leaveCode === "EL" ||
                                //   timeOffData?.leaveCode === "BL" ||
                                //   timeOffData?.leaveCode === "CL" ||
                                //   timeOffData?.leaveCode === "SL" ||
                                //   timeOffData?.isConsumed
                                // }
                                />
                              )}
                            />
                          </div>
                        </div>
                        {/* Holiday Start*/}
                        <div>
                          <div className="w-full mt-8">
                            <label className="text-400 font-medium text-gray-300 block mb-2">
                              Title
                              <span className="text-primary-100 ps-0.5">*</span>
                            </label>
                            <Field
                              name="title"
                              render={({ field }: any) => (
                                <>
                                  <TextInput
                                    {...field}
                                    onChange={(e: any) => {
                                      setFieldValue("title", e.target.value);
                                    }}
                                    onBlur={() => {
                                      setFieldTouched("title", true);
                                    }}
                                    placeholder="Enter Leave Name"
                                    type="text"
                                    value={field.value}
                                    disabled={
                                      timeOffData?.leaveCode === "LOP" ||
                                      timeOffData?.leaveCode === "COFF"
                                    }
                                  // disabled={(timeOffData?.leaveCode === "LOP") || (timeOffData?.leaveCode === "ML") || (timeOffData?.leaveCode === "PL") || (timeOffData?.leaveCode === "EL") || (timeOffData?.leaveCode === "BL") || (timeOffData?.leaveCode === "CL") || (timeOffData?.leaveCode === "SL")}
                                  />
                                </>
                              )}
                            />
                          </div>
                          {values?.timeOffType === 0 && (
                            <div className="w-full mt-8">
                              <label className="text-400 font-medium text-gray-300 block mb-2">
                                Type
                                <span className="text-primary-100 ps-0.5">
                                  *
                                </span>
                              </label>
                              <Field
                                name="holidayType"
                                render={({ field }: any) => (
                                  <>
                                    <Dropdown
                                      {...field}
                                      onChange={(e: any) =>
                                        setFieldValue("holidayType", e.value)
                                      }
                                      options={holidayTypeOpt}
                                      type="box"
                                      isSearchable={false}
                                      value={holidayTypeOpt.find(
                                        (option) =>
                                          option.value === values.holidayType
                                      )}
                                      isDisabled={timeOffData?.isConsumed}
                                    // disabled={(timeOffData?.leaveCode === "LOP") || (timeOffData?.leaveCode === "ML") || (timeOffData?.leaveCode === "PL") || (timeOffData?.leaveCode === "EL") || (timeOffData?.leaveCode === "BL") || (timeOffData?.leaveCode === "CL") || (timeOffData?.leaveCode === "SL") || (timeOffData?.isConsumed)}
                                    />
                                  </>
                                )}
                              />
                            </div>
                          )}
                          <div className="w-full mt-8">
                            {values?.timeOffType === 1 && (
                              <label className="text-400 font-medium text-gray-300 block mb-2">
                                Period
                                <span className="text-primary-100 ps-0.5">*</span>
                              </label>
                            )}
                            {values?.timeOffType === 0 ? (
                              <>
                                <div>
                                  <label className="text-400 font-medium text-gray-300 block mb-2">
                                    From
                                    <span className="text-primary-100 ps-0.5">
                                      *
                                    </span>
                                  </label>
                                  <Field
                                    name="date"
                                    render={({ field }: any) => (
                                      <>
                                        <EchoPulseDatePicker>
                                          <div className="w-full monthlyDate">
                                            <DatePicker
                                              {...field}
                                              dateFormat="dd MMM yyyy"
                                              selected={startDate}
                                              onChange={(
                                                date: Date | [Date, Date] | null
                                              ) =>
                                                handleDateChange(
                                                  date,
                                                  setFieldValue,
                                                  values,
                                                  true
                                                )
                                              }
                                              // minDate={new Date()}
                                              placeholderText={
                                                "Select Start Date"
                                              }
                                              disabled={timeOffData?.isConsumed}
                                            // disabled={(timeOffData?.leaveCode === "LOP") || (timeOffData?.leaveCode === "ML") || (timeOffData?.leaveCode === "PL") || (timeOffData?.leaveCode === "EL") || (timeOffData?.leaveCode === "BL") || (timeOffData?.leaveCode === "CL") || (timeOffData?.leaveCode === "SL") || (timeOffData?.isConsumed)}
                                            />
                                          </div>
                                        </EchoPulseDatePicker>
                                      </>
                                    )}
                                  />
                                </div>
                                <div className="mt-2.5">
                                  <label className="text-400 font-medium text-gray-300 block mb-2">
                                    To
                                    <span className="text-primary-100 ps-0.5">
                                      *
                                    </span>
                                  </label>
                                  <Field
                                    name="date"
                                    render={({ field }: any) => (
                                      <>
                                        <EchoPulseDatePicker>
                                          <div className="w-full monthlyDate">
                                            <DatePicker
                                              {...field}
                                              dateFormat="dd MMM yyyy"
                                              selected={endDate}
                                              onChange={(
                                                date: Date | [Date, Date] | null
                                              ) =>
                                                handleDateChange(
                                                  date,
                                                  setFieldValue,
                                                  values,
                                                  false
                                                )
                                              }
                                              minDate={startDate || new Date()}
                                              placeholderText={
                                                "Select End Date"
                                              }
                                              disabled={timeOffData?.isConsumed}
                                            //disabled={(timeOffData?.leaveCode === "LOP") || (timeOffData?.leaveCode === "ML") || (timeOffData?.leaveCode === "PL") || (timeOffData?.leaveCode === "EL") || (timeOffData?.leaveCode === "BL") || (timeOffData?.leaveCode === "CL") || (timeOffData?.leaveCode === "SL") || (timeOffData?.isConsumed)}
                                            />
                                          </div>
                                        </EchoPulseDatePicker>
                                      </>
                                    )}
                                  />
                                </div>
                              </>
                            ) : (
                              <EchoPulseDatePicker>
                                <div className="monthlyDate">
                                  <DatePicker
                                    selectsRange={true}
                                    startDate={startDate}
                                    endDate={endDate}
                                    onChange={(
                                      date: Date | [Date, Date] | null
                                    ) =>
                                      handleDateChange(
                                        date,
                                        setFieldValue,
                                        values,
                                        false
                                      )
                                    }
                                    // minDate={new Date()}
                                    placeholderText={
                                      "Select Start and End Month"
                                    }
                                    showMonthYearPicker
                                    dateFormat="MMM yyyy"
                                    className="calendar-dropdown"
                                    onFocus={(e: any) => e.target.blur()}
                                    disabled={
                                      timeOffData?.leaveCode === "LOP" ||
                                      timeOffData?.leaveCode === "COFF" ||
                                      timeOffData?.isConsumed
                                    }
                                  // disabled={(timeOffData?.leaveCode === "LOP") || (timeOffData?.leaveCode === "ML") || (timeOffData?.leaveCode === "PL") || (timeOffData?.leaveCode === "EL") || (timeOffData?.leaveCode === "BL") || (timeOffData?.leaveCode === "CL") || (timeOffData?.leaveCode === "SL") || (timeOffData?.isConsumed)}
                                  />
                                </div>
                              </EchoPulseDatePicker>
                            )}
                          </div>

                          {values?.timeOffType === 1 && (
                            <div className="w-full mt-8">
                              <label className="text-400 font-medium text-gray-300 block mb-2">
                                Maximum Leaves (in days)
                                <span className="text-primary-100 ps-0.5">
                                  *
                                </span>
                              </label>
                              <Field
                                name="maxLeaves"
                                render={({ field }: any) => (
                                  <>
                                    <TextInput
                                      {...field}
                                      onBlur={field.onBlur}
                                      onChange={field.onChange}
                                      placeholder="Enter Leave"
                                      type="number"
                                      value={field.value}
                                      onKeyDown={(
                                        e: React.KeyboardEvent<HTMLInputElement>
                                      ) => {
                                        const regex = /^\d{0,3}(\.\d{0,2})?$/;
                                        if (!regex.test(e.key)) {
                                          e.preventDefault();
                                        }
                                      }}
                                      disabled={
                                        timeOffData?.leaveCode === "LOP" ||
                                        timeOffData?.leaveCode === "COFF" ||
                                        timeOffData?.isConsumed
                                      }
                                    // disabled={(timeOffData?.leaveCode === "LOP") || (timeOffData?.leaveCode === "ML") || (timeOffData?.leaveCode === "PL") || (timeOffData?.leaveCode === "EL") || (timeOffData?.leaveCode === "BL") || (timeOffData?.leaveCode === "CL") || (timeOffData?.leaveCode === "SL") || (timeOffData?.isConsumed)}
                                    />
                                  </>
                                )}
                              />
                              <div className="[&>div>textarea]:h-[5.625rem] mt-8">
                                <label className="text-400 font-medium text-gray-300 block mb-2">
                                  Instructions (if any)
                                </label>
                                <Field
                                  name="instructions"
                                  render={({ field }: any) => (
                                    <>
                                      <Textarea
                                        placeholder="Add a note"
                                        {...field}
                                        onChange={(value: string) => {
                                          setFieldValue("instructions", value);
                                        }}
                                        resize
                                        value={
                                          timeOffData?.leaveCode === "LOP" ||
                                            timeOffData?.leaveCode === "COFF"
                                            ? "You do not have access to edit this time off type."
                                            : timeOffData?.isConsumed
                                              ? "-"
                                              : values.instructions
                                        }
                                        // disabled={timeOffData?.isConsumed}
                                        disabled={
                                          timeOffData?.leaveCode === "LOP" ||
                                          timeOffData?.leaveCode === "COFF" ||
                                          timeOffData?.isConsumed
                                        }
                                      />
                                    </>
                                  )}
                                />
                              </div>
                              {/* {values?.timeOffType === 1 && (
                                <div className="w-full mt-8">
                                  <label className="text-400 font-medium text-gray-300 block mb-2">
                                    Apply Proration?
                                    <span className="text-primary-100 ps-0.5">
                                      *
                                    </span>
                                  </label>
                                  <Field
                                    name="isApplyOnProration"
                                    render={({ field }: any) => (
                                      <>
                                        <Dropdown
                                          {...field}
                                          onChange={
                                            (e: any) =>
                                              setFieldValue(
                                                "isApplyOnProration",
                                                e.value === 0 ? true : false
                                              ) // Convert number to boolean
                                          }
                                          options={prorationType}
                                          type="box"
                                          isSearchable={false}
                                          value={prorationType.find(
                                            (option) =>
                                              option.value ===
                                              (values.isApplyOnProration
                                                ? 0
                                                : 1)
                                          )}
                                          isDisabled={
                                            timeOffData?.leaveCode === "LOP" || timeOffData?.leaveCode === "COFF" ||
                                            timeOffData?.isConsumed
                                          }
                                          //isDisabled={(timeOffData?.leaveCode === "LOP") || (timeOffData?.leaveCode === "ML") || (timeOffData?.leaveCode === "PL") || (timeOffData?.leaveCode === "EL") || (timeOffData?.leaveCode === "BL") || (timeOffData?.leaveCode === "CL") || (timeOffData?.leaveCode === "SL") || (timeOffData?.isConsumed)}
                                        />
                                      </>
                                    )}
                                  />

                                  {values?.isApplyOnProration === true && (
                                    <div className="text-gray-500 text-200 font-normal mt-1">
                                      {getFrequencyText(
                                        values.occurrenceMode,
                                        values.maxLeaves,
                                        daysDifference
                                      )}
                                    </div>
                                  )}
                                  {values.isApplyOnProration === false && (
                                    <div className="text-gray-500 text-200 font-normal mt-1">
                                      {`${
                                        values.maxLeaves
                                      } will be credited at the beginning of ${
                                        startDate &&
                                        months[startDate.getMonth()]
                                      }`}
                                    </div>
                                  )}
                                </div>
                              )}
                              {values?.timeOffType === 1 &&
                                values?.isApplyOnProration === true && (
                                  <div className="w-full mt-8">
                                    <label className="text-400 font-medium text-gray-300 block mb-2">

                                      Proration Frequency
                                      <span className="text-primary-100 ps-0.5">
                                        *
                                      </span>
                                    </label>
                                    <Field
                                      name="occurrenceMode"
                                      render={({ field }: any) => (
                                        <Dropdown
                                          type="box"
                                          placeholder="Select Credit Frequency"
                                          options={selectPeriodOptions}
                                          onChange={(option: any) => {
                                            setFieldValue(
                                              "occurrenceMode",
                                              option.value
                                            );
                                          }}
                                          value={selectPeriodOptions.find(
                                            (option) =>
                                              option.value ===
                                              values.occurrenceMode
                                          )}
                                        />
                                      )}
                                    />
                                  </div>
                                )} */}
                              {values?.timeOffType === 1 && (
                                <>
                                  <div className="text-200 text-[#979797] uppercase font-medium tracking-[0.09rem] mt-16">
                                    Entitlement
                                  </div>
                                  <div className="mt-9">
                                    <label className="text-400 font-medium text-gray-300 mb-2 inline-flex">
                                      Effective after
                                      <span className="text-primary-100 ms-0.5">
                                        *
                                      </span>
                                      <CustomRightToolTip>
                                        <div className="tooltip ms-2">
                                          <div className="w-full">
                                            <Icons
                                              name="info-circle"
                                              variant="stroke"
                                              size={14}
                                              color="#888888"
                                              className="-mb-0.5"
                                            />
                                          </div>
                                          <span className="tooltiptext">
                                            This leave will come in to effect
                                            after the selected period
                                          </span>
                                        </div>
                                      </CustomRightToolTip>
                                    </label>
                                    <div className="flex justify-start items-center relative">
                                      <Field
                                        name="effectiveAfterValue"
                                        render={({ field }: any) => (
                                          <>
                                            <TextInput
                                              {...field}
                                              onBlur={field.onBlur}
                                              onChange={field.onChange}
                                              placeholder=""
                                              type="number"
                                              className="!w-12 !py-[9px] rounded-e-none border-e-none"
                                              value={field.value}
                                              onKeyDown={(
                                                e: React.KeyboardEvent<HTMLInputElement>
                                              ) => {
                                                // Allow only numbers
                                                if (!/\d/.test(e.key)) {
                                                  e.preventDefault();
                                                }
                                              }}
                                              disabled={
                                                timeOffData?.isConsumed
                                              }
                                            />
                                          </>
                                        )}
                                      />
                                      {/* <div className="text-primary-100 text-200 font-normal mt-1 absolute -bottom-5 z-10">
                                        Must be 1 or more
                                      </div> */}
                                      <div className="w-[8.75rem] [&_div]:rounded-s-none [&>.select__control]:!rounded-s-none">
                                        <Field
                                          name="effectiveAfter"
                                          render={({ field }: any) => (
                                            <>
                                              <Dropdown
                                                {...field}
                                                onChange={(e: any) =>
                                                  setFieldValue(
                                                    "effectiveAfter",
                                                    e.value
                                                  )
                                                }
                                                options={effectiveAfterList?.map(
                                                  (org: any) => ({
                                                    label: org.name,
                                                    value: org.id,
                                                  })
                                                )}
                                                type="mdbox"
                                                isSearchable={false}
                                                value={
                                                  effectiveAfterList
                                                    ?.map((org: any) => ({
                                                      label: org.name,
                                                      value: org.id,
                                                    }))
                                                    .find(
                                                      (option: any) =>
                                                        option.value ===
                                                        values.effectiveAfter
                                                    ) || null
                                                }
                                                isDisabled={timeOffData?.isConsumed}
                                              />
                                            </>
                                          )}
                                        />
                                      </div>
                                      <span className="mx-2 text-400 font-medium text-gray-300">
                                        from
                                      </span>
                                      <div className="w-[12rem]">
                                        <Field
                                          name="effectiveFrom"
                                          render={({ field }: any) => (
                                            <>
                                              <Dropdown
                                                {...field}
                                                onChange={(e: any) =>
                                                  setFieldValue(
                                                    "effectiveFrom",
                                                    e.value
                                                  )
                                                }
                                                options={effectiveFromList?.map(
                                                  (org: any) => ({
                                                    label: org.name,
                                                    value: org.id,
                                                  })
                                                )}
                                                type="mdbox"
                                                isSearchable={false}
                                                value={
                                                  effectiveFromList
                                                    ?.map((org: any) => ({
                                                      label: org.name,
                                                      value: org.id,
                                                    }))
                                                    .find(
                                                      (option: any) =>
                                                        option.value ===
                                                        values.effectiveFrom
                                                    ) || null
                                                }
                                                isDisabled={timeOffData?.isConsumed}
                                              />
                                            </>
                                          )}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="mt-8">
                                    <label className="text-400 font-medium text-gray-300 mb-2 inline-flex">
                                      Leave accrual
                                      <span className="text-primary-100 ms-0.5">
                                        *
                                      </span>
                                      <CustomRightToolTip>
                                        <div className="tooltip ms-2">
                                          <div className="w-full">
                                            <Icons
                                              name="info-circle"
                                              variant="stroke"
                                              size={14}
                                              color="#888888"
                                              className="-mb-0.5"
                                            />
                                          </div>
                                          <span className="tooltiptext">
                                            This leave will be credited to
                                            employee's account on selected day
                                          </span>
                                        </div>
                                      </CustomRightToolTip>
                                    </label>
                                    <div className="flex justify-start items-start">
                                      <div className="w-[10.938rem]">
                                        <Field
                                          name="occurrenceMode"
                                          render={({ field }: any) => (
                                            <Dropdown
                                              type="mdbox"
                                              placeholder="Select Frequency"
                                              options={selectPeriodOptions}
                                              onChange={(option: any) => {
                                                setFieldValue(
                                                  "occurrenceMode",
                                                  option.value
                                                );
                                              }}
                                              value={selectPeriodOptions.find(
                                                (option) =>
                                                  option.value ===
                                                  values.occurrenceMode
                                              )}
                                              isDisabled={timeOffData?.isConsumed}
                                            />
                                          )}
                                        />

                                        {values.occurrenceMode !== 4 && (
                                          <div className="text-gray-500 text-200 font-normal mt-1">
                                            {getFrequencyText(
                                              values.occurrenceMode,
                                              values.maxLeaves,
                                              daysDifference
                                            )}
                                          </div>
                                        )}
                                        {values.occurrenceMode === 4 && (
                                          <div className="text-gray-500 text-200 font-normal mt-1">
                                            {`${values.maxLeaves
                                              } will be credited at the beginning of ${startDate &&
                                              months[startDate.getMonth()]
                                              }`}
                                          </div>
                                        )}
                                      </div>
                                      {values.occurrenceMode !== 4 && (
                                        <>
                                          <span className="mx-2 text-400 text-gray-300 mt-2">
                                            on
                                          </span>
                                          <div className="w-[8.75rem]">
                                            <Field
                                              name="accuruedOn"
                                              render={({ field }: any) => (
                                                <>
                                                  <Dropdown
                                                    {...field}
                                                    onChange={(e: any) =>
                                                      setFieldValue(
                                                        "accuruedOn",
                                                        e.value
                                                      )
                                                    }
                                                    options={accuruedOnList?.map(
                                                      (org: any) => ({
                                                        label: org.name,
                                                        value: org.id,
                                                      })
                                                    )}
                                                    type="mdbox"
                                                    isSearchable={false}
                                                    value={
                                                      accuruedOnList
                                                        ?.map((org: any) => ({
                                                          label: org.name,
                                                          value: org.id,
                                                        }))
                                                        .find(
                                                          (option: any) =>
                                                            option.value ===
                                                            values.accuruedOn
                                                        ) || null
                                                    }
                                                    isDisabled={timeOffData?.isConsumed}
                                                  />
                                                </>
                                              )}
                                            />
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                  {/* <div className="mt-8">
                                    <div className="flex justify-start items-center mb-3">
                                      <ToggleButton
                                        label=""
                                        defaultChecked={
                                          values.isCarryForwardAllowed
                                        }
                                        onChange={(checked: boolean) =>
                                          setFieldValue(
                                            "isCarryForwardAllowed",
                                            checked
                                          )
                                        }
                                        disabled={timeOffData?.isConsumed}
                                      />
                                      <label className="text-gray-300 text-400 font-medium ms-1">
                                        Carry Forward
                                      </label>
                                      <CustomRightToolTip>
                                        <div className="tooltip ms-2">
                                          <div className="w-full">
                                            <Icons
                                              name="info-circle"
                                              variant="stroke"
                                              size={14}
                                              color="#888888"
                                              className="-mb-0.5"
                                            />
                                          </div>
                                          <span className="tooltiptext">
                                            The number of leaves that will be
                                            carried forward to next period for
                                            this leave type
                                          </span>
                                        </div>
                                      </CustomRightToolTip>
                                    </div>
                                    <Field
                                      name="carryForwardUpperLimit"
                                      render={({ field }: any) => (
                                        <>
                                          <TextInput
                                            {...field}
                                            onBlur={field.onBlur}
                                            onChange={field.onChange}
                                            className="!w-36 !py-[9px]"
                                            placeholder="Enter Limit"
                                            type="number"
                                            value={field.value}
                                            disabled={
                                              !values.isCarryForwardAllowed || timeOffData?.isConsumed
                                            }
                                            onKeyDown={(
                                              e: React.KeyboardEvent<HTMLInputElement>
                                            ) => {
                                              // Allow only numbers
                                              if (!/^\d$/.test(e.key)) {
                                                e.preventDefault();
                                              }
                                            }}

                                          />
                                        </>
                                      )}
                                    />
                                    {errors.carryForwardUpperLimit &&
                                      touched.carryForwardUpperLimit && (
                                        <div className="text-primary-100 text-200 font-normal mt-1">
                                          {String(errors.carryForwardUpperLimit)}
                                        </div>
                                      )}
                                  </div> */}
                                  <div className="mt-8">
                                    <div className="flex justify-start items-center mb-3">
                                      <ToggleButton
                                        label=""
                                        defaultChecked={
                                          values.isLeaveAdjustmentAllowed
                                        }
                                        onChange={(checked: boolean) =>
                                          setFieldValue(
                                            "isLeaveAdjustmentAllowed",
                                            checked
                                          )
                                        }
                                        disabled={timeOffData?.isConsumed}
                                      />
                                      <label className="text-400 font-medium text-gray-300 inline-flex">
                                        Maximum balance (Including accrual)
                                        <span className="text-primary-100 ms-0.5">
                                          *
                                        </span>
                                        <CustomRightToolTip>
                                          <div className="tooltip ms-2">
                                            <div className="w-full">
                                              <Icons
                                                name="info-circle"
                                                variant="stroke"
                                                size={14}
                                                color="#888888"
                                                className="-mb-0.5"
                                              />
                                            </div>
                                            <span className="tooltiptext">
                                              Balance Adjustment: Monthly - Start
                                              of the period
                                            </span>
                                          </div>
                                        </CustomRightToolTip>
                                      </label>
                                    </div>
                                    <div className="flex justify-start gap-8 items-center mt-4 relative">
                                      <div className="flex justify-start items-center">
                                        {/* <label className="text-400 font-medium text-gray-300 block me-2">
                                          Max balance
                                        </label> */}
                                        <div className="w-[4.25rem]">
                                          <Field
                                            name="accrualUpperLimit"
                                            render={({ field }: any) => (
                                              <>
                                                <TextInput
                                                  {...field}
                                                  onBlur={field.onBlur}
                                                  onChange={field.onChange}
                                                  className="!py-[9px]"
                                                  placeholder=""
                                                  type="number"
                                                  value={field.value}
                                                  onKeyDown={(
                                                    e: React.KeyboardEvent<HTMLInputElement>
                                                  ) => {
                                                    // Allow only numbers
                                                    if (!/^\d$/.test(e.key)) {
                                                      e.preventDefault();
                                                    }
                                                  }}
                                                  disabled={!values.isLeaveAdjustmentAllowed || timeOffData?.isConsumed}
                                                />
                                              </>
                                            )}
                                          />
                                          {errors.accrualUpperLimit &&
                                            touched.accrualUpperLimit && (
                                              <div className="text-primary-100 text-200 font-normal mt-1 absolute left-0 -bottom-5">
                                                {String(errors.accrualUpperLimit)}
                                              </div>
                                            )}
                                        </div>
                                        <label className="text-400 font-medium text-gray-300 block me-2 ml-2">
                                          day(s)
                                        </label>
                                        {/* <div className="text-primary-100 text-200 font-normal mt-1 absolute left-0 -bottom-5">
                                          Please enter a valid number
                                        </div> */}
                                      </div>
                                      <div className="flex justify-end items-center">
                                        <label className="text-400 font-medium text-gray-300 block me-2">
                                          Adjusted
                                        </label>
                                        <div className="w-[8.75rem]">
                                          <div className={`text-400 font-medium text-gray-300 block me-2 ${values.isLeaveAdjustmentAllowed || values.leaveAdjustmentMode ? "text-opacity-100" : "text-opacity-40"}`}>Monthly</div>
                                          {/* <Field
                                            name="leaveAdjustmentMode"
                                            render={({ field }: any) => (
                                              <>
                                                <Dropdown
                                                  {...field}
                                                  onChange={(e: any) =>
                                                    setFieldValue(
                                                      "leaveAdjustmentMode",
                                                      e.value
                                                    )
                                                  }
                                                  options={leaveAdjustList?.map(
                                                    (org: any) => ({
                                                      label: org.name,
                                                      value: org.id,
                                                    })
                                                  )}
                                                  type="mdbox"
                                                  placeholder="select"
                                                  isSearchable={false}
                                                  value={
                                                    leaveAdjustList
                                                      ?.map((org: any) => ({
                                                        label: org.name,
                                                        value: org.id,
                                                      }))
                                                      .find(
                                                        (option: any) =>
                                                          option.value ===
                                                          values.leaveAdjustmentMode
                                                      ) || null
                                                  }
                                                  isDisabled={timeOffData?.isConsumed}
                                                />
                                              </>
                                            )}
                                          /> */}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="h-auto py-10">
                        <div className="">
                          {values?.timeOffType === 0 && (
                            <>
                              <Typography
                                variant="h6"
                                className="font-bold text-gray-300"
                              >
                                Details
                              </Typography>
                              {/* Holiday Start */}
                              <div>
                                <Typography
                                  size="lg"
                                  variant="p"
                                  className="text-gray-700 font-medium mt-2.5"
                                >
                                  Select Day Types
                                </Typography>
                                {values.details.map(
                                  (detail: any, index: number) => (
                                    <div key={index}>
                                      <div className="flex justify-start items-center gap-4 mt-5">
                                        <div className="text-500 text-gray-300 font-normal">
                                          {format(detail.holidayDate, "dd MMM")}
                                          {/* {detail.holidayDate}{" "} */}
                                          {/* Render the date */}
                                        </div>
                                        <div className="w-[6.375rem]">
                                          <Dropdown
                                            onChange={(selectedDayType: any) =>
                                              setFieldValue(
                                                `details[${index}].holidayDayType`,
                                                selectedDayType.value
                                              )
                                            }
                                            options={dayType}
                                            type="mdbox"
                                            isSearchable={false}
                                            value={dayType.find(
                                              (option) =>
                                                option.value ===
                                                detail.holidayDayType
                                            )}
                                          />
                                        </div>
                                        <div>day</div>
                                      </div>
                                      {detail.holidayDayType === 1 && (
                                        <div className="mt-5">
                                          <label className="text-400 font-medium text-gray-300 block mb-2">
                                            Select Half day period
                                            <span className="text-primary-100 ps-0.5">
                                              *
                                            </span>
                                          </label>
                                          <div className="flex justify-start items-center gap-6">
                                            <Field
                                              type="radio"
                                              name={`details[${index}].halfDayType`}
                                              value={0}
                                              render={({ field }: any) => (
                                                <RadioButton
                                                  label="First Half"
                                                  {...field}
                                                  onChange={() =>
                                                    setFieldValue(
                                                      `details[${index}].halfDayType`,
                                                      0
                                                    )
                                                  }
                                                  selectedValue={
                                                    detail.halfDayType
                                                  }
                                                />
                                              )}
                                            />
                                            <Field
                                              type="radio"
                                              name={`details[${index}].halfDayType`}
                                              value={1}
                                              render={({ field }: any) => (
                                                <RadioButton
                                                  label="Second Half"
                                                  {...field}
                                                  onChange={() =>
                                                    setFieldValue(
                                                      `details[${index}].halfDayType`,
                                                      1
                                                    )
                                                  }
                                                  selectedValue={
                                                    detail.halfDayType
                                                  }
                                                />
                                              )}
                                            />
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  )
                                )}
                              </div>
                            </>
                          )}
                          {values?.timeOffType === 1 && (
                            <>
                              <div className="text-200 text-[#979797] uppercase font-medium">
                                Applicability
                              </div>
                              <div className="mt-10 relative" ref={dropdownRef}>
                                <div className="flex justify-between items-center px-3.5 py-4 bg-gray-200 rounded-md w-full cursor-pointer" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                                  <div className="text-400 text-gray-300 font-medium">
                                    Applicable to{" "}
                                    <span className="text-gray-700">
                                      (Optional)
                                    </span>
                                  </div>
                                  <Icons
                                    name="arrow-bottom"
                                    variant="stroke"
                                    size={16}
                                    className=""
                                  />
                                </div>
                                {isDropdownOpen && (
                                  <div className="bg-white border border-gray-100 rounded-md shadow-200 w-full absolute left-0 top-[3.063rem] z-50">
                                    {filteredOptions.map((option, index) => (
                                      <li
                                        key={index}
                                        className="py-4 px-5 relative font-medium w-full flex justify-start items-center gap-2 hover:bg-[#F4F4F4]"
                                      >
                                        <RadioButton
                                          label={option}
                                          value={option}
                                          onChange={(e: any) => handleOptionSelect(option, e)}
                                          name="applicableTo"
                                          size="md"
                                          disabled={timeOffData?.isConsumed}
                                        />
                                      </li>
                                    ))}
                                  </div>
                                )}
                              </div>
                              <div className="">
                                <div className="w-full mt-10 border-b border-[#E8E8E8] pb-10">
                                  {/* {selectedOptions.map((option) => {
                                    const name = option.split('.')[0]; */}
                                  {Array.from(new Set(selectedOptions.map(option => option.split('.')[0])))
                                    .map((name, index) => {
                                      // console.log("Name derived from option:", name); 
                                      // console.log(getListForOption(name), "List returned for", name);
                                      return (
                                        <div className="flex justify-start items-start gap-4 mt-8 pe-5" key={index}>
                                          <div className="w-[10rem]">
                                            <TextInput
                                              type="text"
                                              placeholder="Name"
                                              value={name}
                                              onChange={function noRefCheck() { }}
                                            />
                                          </div>
                                          <div className="flex justify-start items-start gap-5 flex-1 relative">
                                            <div className={`${timeOffData?.isConsumed ? 'pointer-events-none opacity-50' : 'cursor-pointer'}`}>
                                              <TimeOffSearchType
                                                list={getListForOption(name)} option={name}
                                                selectedMember={applicableMembers}
                                                setSelectedMember={setApplicableMembers}
                                                setFieldValue={setFieldValue}
                                                type={"applicable"}
                                                initialSelectedMembers={selectedOptions
                                                  // timeOffData?.timeOffType === 0
                                                  //   ? []
                                                  //   : selectedOptions
                                                }
                                              // isDisabled={timeOffData?.isConsumed}
                                              />
                                            </div>
                                            <div className={`mt-4 absolute -right-7 top-0 ${timeOffData?.isConsumed ? 'pointer-events-none opacity-50' : 'cursor-pointer'}`}
                                              // onClick={() => setSelectedOptions(selectedOptions.filter((opt) => opt.split('.')[0] !== name))}
                                              onClick={() => {
                                                const updatedSelectedOptions = selectedOptions.filter((opt) => opt.split('.')[0] !== name);
                                                setSelectedOptions(updatedSelectedOptions);
                                                const fieldKey = getKeyForOption(name);
                                                if (fieldKey) {
                                                  setFieldValue(fieldKey, []);
                                                }
                                              }}
                                            >
                                              <Icons
                                                name="delete"
                                                variant="stroke"
                                                size={18}
                                                className="[&>svg>path]:stroke-primary-100"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  {!isNotApplicableSelected && (<>
                                    <div className="mt-6 text-400 font-medium text-[#8D8D8D] text-center">
                                      OR
                                    </div>

                                    <div className="mt-2">
                                      <label className="text-400 font-medium text-gray-300 block mb-2">
                                        Find employee
                                        {/* <span className="text-primary-100 ps-0.5">
                                        *
                                      </span> */}
                                      </label>
                                      <TimeOffSearchType list={userLists}
                                        option={""}
                                        selectedMember={applicableMembers}
                                        setSelectedMember={setApplicableMembers} setFieldValue={setFieldValue} initialSelectedMembers={
                                          timeOffData?.timeOffType === 0
                                            ? []
                                            : selectedEmployee
                                        }
                                        type={"applicable"}
                                        timeOffData={timeOffData}
                                        onChange={handleApplicableSelection}
                                      />
                                    </div>
                                  </>)}
                                </div>
                              </div>
                              <div className="mt-10 relative">
                                <div className="flex justify-between items-center px-3.5 py-4 bg-gray-200 rounded-md w-full" onClick={() => setIsDropdownOpens(!isDropdownOpens)}>
                                  <div className="text-400 text-gray-300 font-medium">
                                    Not Applicable to{" "}
                                    <span className="text-gray-700">
                                      (Optional)
                                    </span>
                                  </div>
                                  <Icons
                                    name="arrow-bottom"
                                    variant="stroke"
                                    size={16}
                                    className=""
                                  />
                                </div>
                                {isDropdownOpens && (
                                  <div className="bg-white border border-gray-100 rounded-md shadow-200 w-full absolute left-0 top-[3.063rem] z-50">
                                    {filteredOptions.map((option, index) => (
                                      <li
                                        key={index}
                                        className="py-4 px-5 relative font-medium w-full flex justify-start items-center gap-2 hover:bg-[#F4F4F4]"
                                      >
                                        <RadioButton
                                          label={option}
                                          value={option}
                                          onChange={() => handleOptionSelects(option)}
                                          name="notApplicableTo"
                                          size="md"
                                          disabled={timeOffData?.isConsumed}
                                        />
                                      </li>
                                    ))}
                                  </div>
                                )}
                              </div>
                              <div className="">
                                <div className="w-full mt-10 border-b border-[#E8E8E8] pb-10">
                                  {/* {notSelectedOptions.map((option) => {
                                    const name = option.split('-')[0]; */}
                                  {Array.from(new Set(notSelectedOptions.map(option => option.split('.')[0])))
                                    .map((name, index) => {
                                      return (
                                        <div className="flex justify-start items-start gap-4 mt-8 pe-5" key={index}>
                                          <div className="w-[10rem]">
                                            <TextInput
                                              type="text"
                                              placeholder="Name"
                                              value={name}
                                              onChange={function noRefCheck() { }}
                                            />
                                          </div>
                                          <div className="flex justify-start items-start gap-5 flex-1 relative">
                                            <div className={`${timeOffData?.isConsumed ? 'pointer-events-none opacity-50' : 'cursor-pointer'}`}>
                                              <TimeOffSearchType
                                                list={getListForOption(name)} setSelectedMember={setNotApplicableMembers} option={name}
                                                selectedMember={notApplicableMembers} setFieldValue={setFieldValue} type={"notApplicable"} initialSelectedMembers={notSelectedOptions
                                                  // timeOffData?.timeOffType === 0
                                                  //   ? []
                                                  //   : notSelectedOptions
                                                }
                                              />
                                            </div>
                                            <div className={`mt-4 absolute -right-7 top-0 ${timeOffData?.isConsumed ? 'pointer-events-none opacity-50' : 'cursor-pointer'}`}
                                              // onClick={() => setNotSelectedOptions(notSelectedOptions.filter((opt) => opt.split('.')[0] !== name))}
                                              onClick={() => {
                                                const updatedSelectedOptions = notSelectedOptions.filter((opt) => opt.split('.')[0] !== name);
                                                setNotSelectedOptions(updatedSelectedOptions);
                                                const fieldKey = getKeyForOption(name);
                                                if (fieldKey) {
                                                  setFieldValue(fieldKey, []);
                                                }
                                              }}
                                            >
                                              <Icons
                                                name="delete"
                                                variant="stroke"
                                                size={18}
                                                className="[&>svg>path]:stroke-primary-100"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  {!isApplicableSelected && (<>
                                    <div className="mt-6 text-400 font-medium text-[#8D8D8D] text-center">
                                      OR
                                    </div>
                                    <div className="mt-2">
                                      <label className="text-400 font-medium text-gray-300 block mb-2">
                                        Find employee
                                        {/* <span className="text-primary-100 ps-0.5">
                                        *
                                      </span> */}
                                      </label>
                                      <TimeOffSearchType list={userLists}
                                        option={""}
                                        selectedMember={notApplicableMembers}
                                        setSelectedMember={setNotApplicableMembers} setFieldValue={setFieldValue}
                                        type={"notApplicable"} initialSelectedMembers={
                                          timeOffData?.timeOffType === 0
                                            ? []
                                            : notSelectedEmployee
                                        }
                                        timeOffData={timeOffData}
                                        onChange={handleNotApplicableSelection}
                                      />
                                    </div>
                                  </>)}
                                </div>
                              </div>
                              <div className="mt-16">
                                <div className="text-200 text-[#979797] uppercase font-medium tracking-[0.09rem]">
                                  RESTRICTIONS
                                </div>
                                <div className="flex justify-start items-center mt-8">
                                  <ToggleButton
                                    label=""
                                    defaultChecked={
                                      values.isLeaveSandwitchAllowed
                                    }
                                    onChange={(checked: boolean) =>
                                      setFieldValue(
                                        "isLeaveSandwitchAllowed",
                                        checked
                                      )
                                    }
                                    disabled={timeOffData?.isConsumed}
                                  />
                                  <label className="text-gray-300 text-400 font-medium me-1.5 ms-1">
                                    Leave Sandwich Policy
                                  </label>
                                </div>
                                {values.isLeaveSandwitchAllowed === true && (
                                  <>
                                    <div className="mt-8">
                                      <label className="text-400 font-medium text-gray-300 block mb-3">
                                        Weekend between leave period
                                        <span className="text-primary-100 ps-0.5">
                                          *
                                        </span>
                                      </label>

                                      {leaveSandwichList.map((option: any) => (
                                        <div
                                          key={option.id}
                                          className={
                                            option.id > 0 ? "mt-2" : ""
                                          }
                                        >
                                          <RadioButton
                                            label={option.name}
                                            value={String(option.id)}
                                            selectedValue={String(
                                              values.weekendSandwich
                                            )}
                                            onChange={(value: string) =>
                                              setFieldValue(
                                                "weekendSandwich",
                                                parseInt(value)
                                              )
                                            }
                                            name="weekendSandwich"
                                            size="md"
                                            disabled={timeOffData?.isConsumed}
                                          />
                                        </div>
                                      ))}
                                    </div>
                                    <div className="mt-8">
                                      <label className="text-400 font-medium text-gray-300 block mb-3">
                                        Holidays between leave period
                                        <span className="text-primary-100 ps-0.5">
                                          *
                                        </span>
                                      </label>
                                      {leaveSandwichList.map((option: any) => (
                                        <div
                                          key={option.id}
                                          className={
                                            option.id > 0 ? "mt-2" : ""
                                          }
                                        >
                                          <RadioButton
                                            label={option.name}
                                            value={String(option.id)}
                                            selectedValue={String(
                                              values.holidaySandwich
                                            )}
                                            onChange={(value: string) =>
                                              setFieldValue(
                                                "holidaySandwich",
                                                parseInt(value)
                                              )
                                            }
                                            name="holidaySandwich"
                                            size="md"
                                            disabled={timeOffData?.isConsumed}
                                          />
                                        </div>
                                      ))}
                                    </div>
                                  </>
                                )}
                                <div className="mt-8">
                                  <label className="text-400 font-medium text-gray-300 block mb-3">
                                    Allow requests for
                                    <span className="text-primary-100 ps-0.5">
                                      *
                                    </span>
                                  </label>
                                  {/* <div className="flex justify-start items-center gap-3">
                                    <Field
                                      name="isBackwardEntryAllowed"
                                      render={({ field }: any) => (
                                        <>
                                          <Checkbox
                                            checked={
                                              values.isBackwardEntryAllowed
                                            }
                                            onChange={() =>
                                              setFieldValue(
                                                "isBackwardEntryAllowed",
                                                !values.isBackwardEntryAllowed
                                              )
                                            }
                                            size="md"
                                            disabled={timeOffData?.isConsumed}
                                          />
                                        </>
                                      )}
                                    />
                                    <label className="text-400 text-gray-300 font-medium -mt-1.5">
                                      Past dates
                                    </label>
                                  </div> */}
                                  {/* {values.isBackwardEntryAllowed && ( */}
                                  <div className="flex justify-start items-center ps-4 mt-2 gap-2">
                                    <div className="flex justify-start items-center gap-2">
                                      <Checkbox
                                        checked={
                                          values.isBackwardEntryAllowed
                                        }
                                        onChange={() =>
                                          setFieldValue(
                                            "isBackwardEntryAllowed",
                                            !values.isBackwardEntryAllowed
                                          )
                                        }
                                        disabled={timeOffData?.isConsumed}
                                        size="md"
                                      />
                                      <label className="text-400 text-gray-300 font-medium -mt-1.5">
                                        Past dates
                                      </label>
                                    </div>
                                    <Field
                                      name="noOfAllowedPastDates"
                                      render={({ field }: any) => (
                                        <>
                                          <TextInput
                                            {...field}
                                            onBlur={field.onBlur}
                                            onChange={field.onChange}
                                            placeholder=""
                                            type="number"
                                            className="!w-12 !py-[9px]"
                                            value={field.value}
                                            onKeyDown={(
                                              e: React.KeyboardEvent<HTMLInputElement>
                                            ) => {
                                              // Allow only numbers
                                              if (!/\d/.test(e.key)) {
                                                e.preventDefault();
                                              }
                                            }}
                                            disabled={!values.isBackwardEntryAllowed || timeOffData?.isConsumed}
                                          />{" "}
                                        </>
                                      )}
                                    />
                                    <label className="text-400 text-gray-300 font-medium">
                                      day(s)
                                    </label>
                                  </div>
                                  {/* )} */}
                                </div>
                              </div>
                            </>
                          )}

                          {/* Holiday End */}
                        </div>
                      </div>
                    </div>
                  </ModalBody>
                  <ModalFooter>
                    <div className="flex justify-start gap-5">
                      {/* {timeOffData?.leaveCode !== "LOP"  ? ( */}
                      {timeOffData?.leaveCode !== "LOP" &&
                        timeOffData?.leaveCode !== "COFF" &&
                        !(
                          timeOffData?.holidayType === 0 &&
                          new Date(timeOffData?.startDate) < new Date()
                        ) ? (
                        <>
                          <Button
                            label="Update"
                            onClick={function noRefCheck() { }}
                            variant="primary"
                            size="large"
                            isDisabled={
                              !(values.title && values.title.trim()) ||
                              (values?.timeOffType === 1 &&
                                !(
                                  values.maxLeaves &&
                                  String(values.maxLeaves).trim()
                                )) || (values.isCarryForwardAllowed &&
                                  (!values.carryForwardUpperLimit ||
                                    values.carryForwardUpperLimit < 0.01 ||
                                    values.carryForwardUpperLimit > 99))
                              // || (
                              // (!values.accrualUpperLimit ||
                              //   values.accrualUpperLimit < 0.01 ||
                              //   values.accrualUpperLimit > 99))
                            }
                          />
                          <Button
                            label="Cancel"
                            onClick={onClose}
                            variant="outline"
                            size="large"
                          />
                        </>
                      ) : (
                        <Button
                          label="Okay"
                          onClick={onClose}
                          variant="primary"
                          size="large"
                        />
                      )}
                    </div>
                  </ModalFooter>
                </>
              )}
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default AdminEditTimeOffModal;
